import { useMemo } from 'react';

import { useDirectusCollectionList } from '../data/useDirectusCollectionList.ts';
import { parseEventOptions } from './parseEventOptions.ts';

export const useEventOptions = () => {
  const { data: categoryData, isPending: categoryIsPending } = useDirectusCollectionList('categories');
  const { data: targetAudienceData, isPending: targetAudienceIsPending } =
    useDirectusCollectionList('target_audiences');
  const { data: detailData, isPending: detailIsPending } = useDirectusCollectionList('event_details');

  const parsedCategoryData = useMemo(() => {
    return categoryData ? parseEventOptions(categoryData, 'title') : [];
  }, [categoryData]);

  const parsedTargetAudienceData = useMemo(() => {
    return targetAudienceData ? parseEventOptions(targetAudienceData, 'name') : [];
  }, [targetAudienceData]);

  const parsedDetailData = useMemo(() => {
    return detailData ? parseEventOptions(detailData, 'text') : [];
  }, [detailData]);

  return {
    category: {
      data: parsedCategoryData,
      isPending: categoryIsPending,
    },
    targetAudiences: {
      data: parsedTargetAudienceData,
      isPending: targetAudienceIsPending,
    },
    detail: {
      data: parsedDetailData,
      isPending: detailIsPending,
    },
  };
};
